import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a028f78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__score-item-bubble" }
const _hoisted_2 = ["title"]

import { computed, toRefs } from 'vue';

  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'score-item-bubble',
  props: {
    scoreLevel: {
      type: Object,
      default: null,
    },
    currentValue: {
      type: Number,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    hiddenIfInactive: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    black: {
      type: Boolean,
      default: false,
    },
    tooltipPrefix: {
      type: String,
      default: "",
    },
  },
  emits: ["trigger"],
  setup(__props) {

  const props = __props;

  

  const { scoreLevel, currentValue, active, light, black} = toRefs(props);

  const isActive = computed(() => active.value || scoreLevel.value.value === currentValue.value)
   
  const bubbleCssClasses = computed(() => {
    const result = [];

    result.push(themingCssClass("border"));

    if (isActive.value) {
      result.push("bubble-is-selected");
      result.push(themingCssClass("inverted"));
    } else {
      result.push("bubble-is-not-selected");
      result.push(themingCssClass("normal"));
    }

    if (light.value) {
      result.push("light");
    }

    if (black.value) {
      result.push("black");
    }

    result.push(scoreLevel.value.item_type);

    // [
    //   { active: active || scoreLevel.value == currentValue, light },
    //   scoreLevel.item_type,
    // ]

    return result;
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(scoreLevel))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({
        visibility:
          __props.hiddenIfInactive && !_unref(active) && _unref(scoreLevel).value !== _unref(currentValue)
            ? 'hidden'
            : 'initial',
      }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('trigger'))),
          class: _normalizeClass(bubbleCssClasses.value),
          title: __props.tooltipPrefix + _unref(scoreLevel).tooltip
        }, _toDisplayString(_unref(scoreLevel).label), 15, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})